class ListAntrian {
  constructor (data) {
    Object.assign(this, data)
  }
}

export default ListAntrian
